<script setup>
import {inject, ref, watch} from "vue";
import SecuredBadge from "./SecuredBadge.vue";
import FileFilter from "./FileFilter.vue";
import FileSearch from "./FileSearch.vue";

const emit = defineEmits(['shareLink']);

const { CHANNEL_PRIVATE, CHANNEL_PUBLIC, channel_selected, selectChannel } = inject('channel');
const router = inject('router');
const { getAuthBearer,userLoggedIn,openLogin,userIsEmployee } = inject('userApi');
const { file_filter, setFilter, resetFilter, showSearch, showFilter, resetSearch } = inject('filter');

const directory_depth = ref(1);
const share_modal = ref();

const registerShareModal = function (modal) {
  share_modal.value = modal;
};

watch(router.currentRoute,(ro)=>{
    let route_elements = ro.name.split('.');
    let channel = route_elements[0];
    directory_depth.value = route_elements.length;
    selectChannel(channel);
    resetSearch();
});

watch(userLoggedIn, (is_logged_in)=>{
  let route_elements = channel_selected.value.split('.');
  let channel = route_elements[0];
  if(channel === CHANNEL_PRIVATE && !is_logged_in){
    router.replace({ name: CHANNEL_PUBLIC });
  }
});


const openPrivateChannel = function () {
  if(userLoggedIn.value){
    router.replace({ name: CHANNEL_PRIVATE });
  }else{
    let redirect_to = encodeURI(window.location.pathname+router.resolve({ name: CHANNEL_PRIVATE}).href);
    openLogin(redirect_to);
  }
};

const navigateBack = function () {
  showFilter(false);
  router.replace({ name: channel_selected.value });
};

const shareLink = function () {
  emit('shareLink',document.URL);
};

const toggleSearch = () => {
  showSearch(!file_filter.value.show_search);
}

const toggleFilter = () => {
  showFilter(!file_filter.value.show_filter);
}

</script>
<template>
    <teleport to="body">
      <FileFilter v-if="directory_depth === 2" v-show="file_filter.show_filter"></FileFilter>
      <FileSearch v-if="directory_depth === 1 && file_filter.show_search"></FileSearch>
      <div class="footer container-fluid position-fixed bottom-0 z-2" :class="{'private': CHANNEL_PRIVATE === channel_selected}">
        <div class="row justify-content-center">
          <div class="col-10 align-self-center text-center" v-if="directory_depth === 1">
              <a href="#" class="btn btn-footer" :class="{'active': file_filter.show_search}" @click.prevent="toggleSearch" role="button"><i class="icon search"></i></a>
              <a href="/#/" class="btn btn-footer" :class="{'active': CHANNEL_PUBLIC === channel_selected}" role="button"><i class="icon public"></i></a>
              <a href="/#/private" class="btn btn-footer" :class="{'active': CHANNEL_PRIVATE === channel_selected}" @click.prevent="openPrivateChannel" role="button"><i class="icon private"><SecuredBadge :class="'secured'"/></i></a>
          </div>
          <div class="col-10 align-self-center text-center" v-else>
            <a href="#" @click.prevent="navigateBack" class="btn btn-footer" >
              <i class="icon back"></i>
            </a>
            <a href="#" class="btn btn-footer" :class="{'active': file_filter.show_filter}" @click.prevent="toggleFilter" role="button">
              <i class="icon filter"></i>
            </a>
            <a href="#" @click.prevent="shareLink" class="btn btn-footer">
              <i class="icon share">
                <SecuredBadge :class="['position-relative','secured']" v-if="CHANNEL_PRIVATE === channel_selected"/>
              </i>
            </a>
          </div>
        </div>
      </div>
    </teleport>

</template>